import { debugLog } from "./logging";

export const PYLON_APP_ID = "d24ab7d7-be88-4826-9537-c3d9503aa177";

export function initPylon(userInfo) {
  try {
    window.pylon = {
      chat_settings: {
        app_id: PYLON_APP_ID,
        email: userInfo.user.email,
        name: userInfo.fullName,

        // (Optional) If you have the user's profile image available through something like Auth0
        //avatar_url: "USER_PROFILE_IMAGE_URL",

        // (Optional) If you are using Pylon's identity verification
        //email_hash: "USER_EMAIL_HASH",

        // (Optional) If you want to force association of an issue/contact with a certain account.
        //account_id: "057a3564-fc1b-4224-9292-dcf718653452",

        // (Optional) If you want to force association of an issue/contact with a certain account.
        // Learn more about external IDs here: https://docs.usepylon.com/pylon-docs/developer/api/external-ids.
        //account_external_id: "ab38e36b-3e28-4e2d-b976-6282735b77eb",
      },
    };
  } catch (err) {
    debugLog("Error initializing Pylon", err);
  }
}
